import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { backgroundTaskDismissed } from "Store/backgroundTasks/actions";
import { makeSelectBackgroundTasks } from "Store/backgroundTasks/selectors";
import ProgressBar from "newComponents/Shared/ProgressBar/ProgressBar";
import colors from "constants/colors";

const BackgroundTasksIndicator: FC = () => {
  const dispatch = useDispatch();
  const tasks = useSelector(makeSelectBackgroundTasks);
  const taskList = Object.values(tasks || {});

  if (!taskList.length) return null;

  return (
    <div className="background-tasks-indicator">
      {taskList.map((task) => {
        const done = task.processed + task.failed;
        const progress = task.total > 0 ? (done / task.total) * 100 : 0;
        return (
          <div className="background-task" key={task.id}>
            <button
              className="background-task-dismiss"
              type="button"
              aria-label="Dismiss"
              onClick={() => dispatch(backgroundTaskDismissed({ id: task.id }))}
            >
              &times;
            </button>
            <ProgressBar
              id={`background-task-${task.id}`}
              header={task.label}
              progress={task.finished ? 100 : progress}
              additional={`${done}/${task.total}`}
              description={
                task.finished
                  ? task.failed > 0
                    ? `Done, ${task.failed} failed`
                    : "Done"
                  : "Assigning..."
              }
              fillColor={task.failed > 0 ? colors.red : undefined}
            />
          </div>
        );
      })}
    </div>
  );
};

export default BackgroundTasksIndicator;
